export const data = {
    en: {
      paragraphs: [
        {
          title: 'Dual education',
          text: 'The Institute for Vocational Training Niedersachsen e.V. cooperates with the Chinese vocational schools to the goal, the training of qualified specialists, which among other things in China active German enterprises inquired. In addition, with its German expertise, the institut supports the development of structures for vocational training based on a dual role model and its formulation.',
        },
      ],
    },
    de: {
      paragraphs: [
        {
          title: 'Duale Ausbildung',
          text: 'Das Institut für Berufsbildung Niedersachsen e.V. kooperiert mit den chinesischen Berufsschulen zum Ziel, die Ausbildung von qualifizierten Fachkräften, die unter anderem von in China tätigen deutschen Unternehmen angefragte. Außerdem unterstützt das Institut mit deutscher Expertise der Aufbau von Strukturen für eine berufliche Bildung nach dualem Vorbild und die Formulierung.',
        },
      ],
    },
};